let headerVue;
document.addEventListener("DOMContentLoaded", function (e) {
  headerVue = Vue.createApp({
    delimiters: ["${", "}"],
    data() {
      return {
        cachedResults: {},
        predictiveSearchResults: null,
        showHeaderBar: true,
        showSearchForm: false,
        activeSubmenu: null,
        activeSubsubmenu: null,
        showMobileMenu: false,
        hideSiteHeader: false,
        prevScrollPos: 0,
        // search optimizations
        searchDebounceId: null,
        searchAbortController: null,
        searchCancelToken: null,
        lastQuery: '',
      };
    },
    mounted() {
      const this_obj = this;
      (this.predictiveSearchResults = document.querySelector(
        "#shopify-section-predictive-search"
      )),
      this.siteHeaderHideShowBehaviour();
      this.adjustDropdown()
      this.searchLimitedCountdown()
      window.addEventListener('resize', this.adjustDropdown)
      //-- init AOS plugin
      AOS.init();

      //-- open cart drawer on first load
      const urlSearchParams = new URLSearchParams(window.location.search);
      const param = urlSearchParams.get("drawer");
      if (param == "true") {
        this_obj.showHeaderCart();
      }

      //-- page overlay clicked
      const page_overlay = document.querySelector(".header-overlay");
      page_overlay.addEventListener("click", function (event) {
        if (window.innerWidth < 1024) {
          this_obj.toggleMobileMenu();
        }
        this_obj.showSearchForm = false;
      });

      //-- page overlay global clicked
      const page_overlay_global = document.querySelector(
        ".page-overlay.header-cart-overlay"
      );
      page_overlay_global.addEventListener("click", function (event) {
        this_obj.showSearchForm = false;
      });

      //-- check no-bar cookie
      if ($360.getCookie("hide_ann_bar") == "true") {
        this_obj.removeAnnBar();
      }

      //-- set menu dropdown top position
      const desktopDropdowns = document.querySelectorAll(
        "#header-con .menu-dropdown"
      );
      const mobileMenuWrapper = document.querySelector(
        "#header-con .mobile-menu-wrapper"
      );
      const headerHeight = document.querySelector(".site-header").offsetHeight;
      const headerMenuHeight = document.querySelector(
        ".site-header .header-con-outer"
      ).offsetHeight;
      if (screen.width > 1023) {
        desktopDropdowns.forEach(function (desktopDropdown) {
          if ($360.getCookie("hide_ann_bar") == "true") {
            desktopDropdown.style.top = `${headerMenuHeight - 1}px`;
          } else {
            desktopDropdown.style.top = `${headerHeight - 1}px`;
          }
        });
      }

      //-- search view all clicked
      document.addEventListener("click", function (e) {
        if (e.target.classList.contains("search-view-all")) {
          e.preventDefault();
          this_obj.clickViewAll();
        }
      });

      //-- account dropdown
      let dropTrigger = document.querySelector('.account-menu-trigger')
      dropTrigger.addEventListener("click", function (e) {
        e.preventDefault();
        const dropp = this.nextElementSibling;
        dropp.classList.toggle("active");
        e.stopPropagation();
      });

      document.addEventListener("click", function (e) {
        const menu = document.querySelector('.account-menu-dropdown');
        const trigger = document.querySelector('.account-menu-trigger');

        if (!menu.contains(e.target) && !trigger.contains(e.target)) {
          menu.classList.remove("active");
        }
      });

      //-- collection filter hover behaviour
      const collection_filter = document.querySelector("#collection-filter");
      if (collection_filter != null) {
        collection_filter.classList.remove("zi-6");
        collection_filter.classList.add("zi-2");

        collection_filter.addEventListener("mouseenter", function (event) {
          event.stopPropagation();
          collection_filter.classList.add("zi-6");
          collection_filter.classList.remove("zi-2");
        });
        collection_filter.addEventListener("mouseleave", function (event) {
          event.stopPropagation();
          const filter_overlay = this.querySelector(".page-overlay");
          if (
            filter_overlay != null &&
            !filter_overlay.classList.contains("active")
          ) {
            collection_filter.classList.add("zi-2");
            collection_filter.classList.remove("zi-6");
          }
        });
      }

      //-- if URL contains #
      if (window.location.href.includes("#")) {
        const delay = setTimeout(() => {
          const scrollTop =
            document.documentElement.scrollTop || document.body.scrollTop || 0;
          const headerHeight =
            document.querySelector("#header-con").offsetHeight;

          window.scrollTo({
            top: scrollTop - headerHeight,
            behavior: "smooth",
          });

          clearTimeout(delay);
        }, 500);
      }
    },
    methods: {
      adjustDropdown(){
        let simpleDropdownMenu = document.querySelectorAll('#site-header .header-dropdown .shdm-simple-dropdown');
        if(window.innerWidth > 1023){
          simpleDropdownMenu.forEach((item) => {
            let thisDropdown = item.closest('.sh-dropdown')
            let theIndex = thisDropdown.getAttribute('data-parent-index')
            let parentMenu = document.querySelector(`#site-header .header-con .parent-index-${theIndex}`);
            let leftPos = parentMenu.getBoundingClientRect().left;
            thisDropdown.style.left = `${leftPos}px`;
          })
        } else {
          simpleDropdownMenu.forEach((item) => {
            let thisDropdown = item.closest('.sh-dropdown')
            thisDropdown.removeAttribute('style')
          })
        }
      },
      toggleCurrencySwitcher(e) {
        e.preventDefault();

        const parent = e.target.closest(".currency-selector");
        if (parent != null) {
          parent.classList.toggle("active");
        }

        return false;
      },
      changeCountry(iso_code, e) {
        e.preventDefault();
        const country_field = e.target
          .closest(".currency-selector")
          .querySelector('input[name="country_code"]');
        country_field.value = iso_code;
        country_field.closest("form").submit();

        return false;
      },
      setCookie(name, value, days) {
        let expires = "";
        if (days) {
          const date = new Date();
          date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
          expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
      },
      closeAnnBar(event) {
        event.preventDefault();

        /* set cookie expired in 2 days */
        this.setCookie("hide_ann_bar", "true", 2);
        this.removeAnnBar();
      },
      removeAnnBar() {
        const site_header = document.querySelector(".site-header");
        const ann_bar = document.querySelector(".header-bar");
        const body = document.querySelector("body");
        const global_content_tm = document.querySelector(
          ".global-content-top-margin"
        );

        if (site_header != null) {
          if (ann_bar != null) {
            ann_bar.remove();
          }

          body.classList.add("no-bar");

          $360.headerHeight =
            site_header.querySelector(".header-con-outer").offsetHeight;
          if (global_content_tm != null) {
            global_content_tm.style.marginTop = `-${ann_bar.offsetHeight}px`;
          }

          if (site_header.classList.contains("transparent")) {
            const first_section = document.querySelector(
              ".global-content-top-margin .shopify-section:first-child"
            );
            if (first_section != null) {
              first_section.style.marginTop = `-${
                $360.headerHeight + ann_bar.offsetHeight
              }px`;
            }
          }
        }
      },
      cancelSearchRequest() {
        try {
          if (this.searchAbortController) {
            this.searchAbortController.abort();
            this.searchAbortController = null;
          }
          if (this.searchCancelToken) {
            this.searchCancelToken('canceled');
            this.searchCancelToken = null;
          }
        } catch (e) {}
      },
      async onInputSearch(event) {
        const keywordRaw = event && event.target ? event.target.value : '';
        const keyword = (keywordRaw || '').trim();
        const searchSuggestion = document.querySelector('.header-search .hsb-search-suggestion');
        const searchResult = document.querySelector('.header-search .hsb-search-result');

        // Guards if elements are missing
        if (!searchSuggestion || !searchResult) {
          return;
        }

        // Clear debounce timer
        if (this.searchDebounceId) {
          clearTimeout(this.searchDebounceId);
          this.searchDebounceId = null;
        }

        // Empty keyword: show suggestions, hide results, cancel in-flight
        if (!keyword) {
          this.cancelSearchRequest();
          this.lastQuery = '';
          searchResult.innerHTML = '';
          searchResult.classList.add('hide-m');
          searchResult.classList.remove('flex');
          searchSuggestion.classList.remove('hide-m');
          return;
        }

        // Set latest query and show result panel immediately
        this.lastQuery = keyword;
        searchResult.classList.remove('hide-m');
        searchResult.classList.add('flex');
        searchSuggestion.classList.add('hide-m');

        // If cached, render instantly while debouncing network
        if (this.cachedResults[keyword]) {
          searchResult.innerHTML = this.cachedResults[keyword];
          try { if ($360 && $360.lazyLoadInstance && $360.lazyLoadInstance.update) { $360.lazyLoadInstance.update(); } } catch (e) {}
          try { if (typeof iWish !== 'undefined' && iWish.checkIwishColl) { setTimeout(() => iWish.checkIwishColl(), 300); } } catch (e) {}
        } else {
          searchResult.innerHTML = 'Searching...';
        }

        // Debounce actual request
        this.searchDebounceId = setTimeout(async () => {
          this.searchDebounceId = null;
          // Cancel previous in-flight request
          this.cancelSearchRequest();
          try {
            let axiosConfig = {};
            if (typeof AbortController !== 'undefined') {
              const controller = new AbortController();
              this.searchAbortController = controller;
              axiosConfig.signal = controller.signal;
            } else if (typeof axios !== 'undefined' && axios.CancelToken) {
              axiosConfig.cancelToken = new axios.CancelToken((c) => {
                this.searchCancelToken = c;
              });
            }
            const q = encodeURIComponent(keyword);
            const res = await axios.get(`/search?view=header&q=${q}`, axiosConfig);
            // Ignore stale responses
            if (keyword !== this.lastQuery) return;
            if (res && res.data) {
              this.cachedResults[keyword] = res.data;
              searchResult.innerHTML = res.data;
              try { if ($360 && $360.lazyLoadInstance && $360.lazyLoadInstance.update) { $360.lazyLoadInstance.update(); } } catch (e) {}
              try { if (typeof iWish !== 'undefined' && iWish.checkIwishColl) { setTimeout(() => iWish.checkIwishColl(), 300); } } catch (e) {}
            }
          } catch (error) {
            // Swallow abort/cancel errors
            const msg = (error && (error.name || error.message)) || '';
            if (msg && (msg.toString().includes('Abort') || msg.toString().includes('canceled'))) {
              return;
            }
            console.error(error);
          } finally {
            this.searchAbortController = null;
            this.searchCancelToken = null;
          }
        }, 300);
      },
      headerSearchHandler(event) {
        const body = document.querySelector("body");
        const keyword_field = document.querySelector('.header-search #hst-input');
        const overlay = document.querySelector('.page-overlay.header-overlay-search')
        this.showSearchForm = !this.showSearchForm;
        if (this.showSearchForm) {
          if (keyword_field) {
            setTimeout(() => {
              keyword_field.focus();             
            }, 300);
          }
          overlay.classList.add('active')
          body.classList.add('overflow')
        } else {
          overlay.classList.remove('active')
          body.classList.remove('overflow')
          // Cancel any in-flight search and reset panels when closing
          this.cancelSearchRequest();
          const searchSuggestion = document.querySelector('.header-search .hsb-search-suggestion');
          const searchResult = document.querySelector('.header-search .hsb-search-result');
          if (searchResult) {
            searchResult.classList.add('hide-m');
            searchResult.classList.remove('flex');
            searchResult.innerHTML = '';
          }
          if (searchSuggestion) {
            searchSuggestion.classList.remove('hide-m');
          }
        }
      },
      handleKeyDown(event) {
        if (event.key === "Enter") {
          window.location.href =
            "/search?type=product&q=" +
            document.querySelector("#search-term").value +
            "";
        }
      },
      searchLimitedCountdown() {
        // Parse dd/mm/YYYY hh:mm
        const searchLimited = document.querySelector('.hsb-limited')
        const searchSuggestion = document.querySelector('.hsb-suggestion')
        const countdownEl = document.querySelector('.header-search .hsblh-countdown-box')
        let countdownDate = null
        if(countdownEl){
          countdownDate = countdownEl.getAttribute('data-countdown')
        }
        if(countdownEl && countdownDate){
          const parts = countdownDate.split(/[/ :]/);
          const targetDate = new Date(parts[2], parts[1] - 1, parts[0], parts[3], parts[4]);
          const countdownInterval = setInterval(updateCountdown, 1000);
          function updateCountdown() {
            const now = new Date();
            const diff = targetDate - now;
  
            const hoursEl = document.querySelector('.hsblh-countdown-box .hsblh-hours');
            const minsEl = document.querySelector('.hsblh-countdown-box .hsblh-mins');
            const secsEl = document.querySelector('.hsblh-countdown-box .hsblh-secs');
            searchLimited.classList.remove('hide-m')
            if(searchSuggestion){
              searchSuggestion.classList.add('hide-m')
              searchSuggestion.classList.remove('flex')
            }
            if (diff <= 0) {
              searchLimited.classList.add('hide-m')
              if(searchSuggestion){
                searchSuggestion.classList.remove('hide-m')
                searchSuggestion.classList.add('flex')
              }
              hoursEl.textContent = '00';
              minsEl.textContent = '00';
              secsEl.textContent = '00';
              clearInterval(countdownInterval);
              return;
            } else {
              if(searchSuggestion){
                searchSuggestion.classList.add('hide-m')
                searchSuggestion.classList.remove('flex')
              }
            }
  
            const totalSeconds = Math.floor(diff / 1000);
            const hours = Math.floor(totalSeconds / 3600);
            const minutes = Math.floor((totalSeconds % 3600) / 60);
            const seconds = totalSeconds % 60;
            if(diff){
              hoursEl.textContent = String(hours).padStart(2, '0');
              minsEl.textContent = String(minutes).padStart(2, '0');
              secsEl.textContent = String(seconds).padStart(2, '0');
            } else {
              if(searchLimited){
                searchLimited.classList.add('hide-m')
              }
              if(searchSuggestion){
                searchSuggestion.classList.remove('hide-m')
                searchSuggestion.classList.add('flex')
              }
            }
          }
  
          updateCountdown();
        } else {
          if(searchLimited){
            searchLimited.classList.add('hide-m')
          }
          if(searchSuggestion){
            searchSuggestion.classList.remove('hide-m')
            searchSuggestion.classList.add('flex')
          }
        }
      },
      clickViewAll() {
        window.location.href =
          "/search?type=product&q=" +
          document.querySelector("#search-term").value +
          "";
      },
      siteHeaderHideShowBehaviour() {
        const doc = document.documentElement;
        const body = document.body;
        const headerHeight =
          document.querySelector(".site-header").offsetHeight;
        let headerBarHeight = 0;
        if (document.querySelector("#header-bar") != null) {
          headerBarHeight = document.querySelector("#header-bar").offsetHeight;
        }

        const headerMenuHeight = document.querySelector(
          ".site-header .header-con-outer"
        ).offsetHeight;
        const siteHeaderObj = document.querySelector(".site-header");
        const mobileMenuWrapper = document.querySelector(
          "#header-con .mobile-menu-wrapper"
        );
        const headerConObj = document.querySelector("#shopify-section-header");
        let announcementBar = document.querySelector("#header-bar");
        let hideHeight = 0;
        let dropdownPos = 0;
        const this_obj = this;

        window.addEventListener("scroll", () => {
          const scrollPos = Math.max(doc.scrollTop, body.scrollTop);
          const scrollDirection =
            scrollPos > this_obj.prevScrollPos ? "down" : "up";

          // Output the scroll down value to the console
          if (scrollDirection == "down" && scrollPos > headerHeight) {
            this_obj.hideSiteHeader = true;
            siteHeaderObj.classList.remove("scroll-top");
            headerConObj.classList.remove("scroll-top");
            siteHeaderObj.classList.add("scroll-down");
            headerConObj.classList.add("scroll-down");

            if (announcementBar != null) {
              hideHeight = announcementBar.offsetHeight;
            }

            headerConObj.style.top = `-${headerHeight}px`;

            //-- hide submenu
            if (
              document.querySelector(`#header-con .menu-dropdown.show`) != null
            ) {
              document
                .querySelector(`#header-con .menu-dropdown.show`)
                .classList.add("waiting-inactive");
              document
                .querySelector(`#header-con .menu-dropdown.show`)
                .classList.remove("show");

              const delay_hide = setTimeout(() => {
                document
                  .querySelector(`#header-con .menu-dropdown.waiting-inactive`)
                  .classList.remove("waiting-inactive");
                this_obj.activeSubmenu = null;
                this_obj.activeSubsubmenu = null;

                clearTimeout(delay_hide);
              }, 50);
            }

            // adjust sticky div on PDP (desktop only)
            if (
              document.querySelector(".product-info-outer-wrapper") != null &&
              screen.width > 1023
            ) {
              const pdp_info_outer_wrapper = document.querySelector(
                ".product-info-outer-wrapper"
              );
              pdp_info_outer_wrapper.style.top = "68px";
            }

            // adjust sticky div for collection tabbed
            if (
              document.querySelector(".collection-tabbed") != null &&
              screen.width > 1023
            ) {
              const collection_tabbed_info = document.querySelector(
                ".collection-tabbed .ctc-tabs"
              );
              collection_tabbed_info.style.top = "40px";
            }

            // adjust sticky div on cart (tablet up)
            if (
              document.querySelector(".cart-right .inner.t-sticky") != null &&
              screen.width > 767
            ) {
              const sticky_elem = document.querySelector(
                ".cart-right .inner.t-sticky"
              );
              sticky_elem.style.top = "50px";
            }
            // adjust collection filter
            if (document.querySelector("#collection-filter")) {
              //const collection_filter_elem = document.querySelector("#collection-filter");
              const collection_filter_elem = document.querySelector("#collection-main-content .overflow-mobile");
              collection_filter_elem.style.top = "0";

              collection_filter_elem.classList.add("going-down");
              collection_filter_elem.classList.remove("going-up");
            }
          } else if (scrollDirection == "up") {
            siteHeaderObj.classList.remove("scroll-down");
            headerConObj.classList.remove("scroll-down");

            // adjust collection filter
            if (document.querySelector("#collection-filter")) {
              //const collection_filter_elem = document.querySelector("#collection-filter");
              const collection_filter_elem = document.querySelector("#collection-main-content .overflow-mobile");
              collection_filter_elem.style.top = `${
                headerHeight - headerBarHeight
              }px`;

              collection_filter_elem.classList.remove("going-down");
              collection_filter_elem.classList.add("going-up");

            }

            // adjust sticky div on PDP (desktop only)
            if (
              document.querySelector(".product-info-outer-wrapper") != null &&
              screen.width > 1023
            ) {
              const pdp_info_outer_wrapper = document.querySelector(
                ".product-info-outer-wrapper"
              );
              pdp_info_outer_wrapper.style.top = "80px";
            }

            // adjust sticky div for collection tabbed
            if (
              document.querySelector(".collection-tabbed") != null &&
              screen.width > 1023
            ) {
              const collection_tabbed_info = document.querySelector(
                ".collection-tabbed .ctc-tabs"
              );
              collection_tabbed_info.style.top = "150px";
            }

            // adjust sticky div on cart (tablet up)
            if (
              document.querySelector(".cart-right .inner.t-sticky") != null &&
              screen.width > 767
            ) {
              const sticky_elem = document.querySelector(
                ".cart-right .inner.t-sticky"
              );
              sticky_elem.style.top = "150px";
            }

            if (scrollPos <= headerHeight) {
              this_obj.hideSiteHeader = false;
              siteHeaderObj.classList.remove("scroll-top");
              headerConObj.classList.remove("scroll-top");

              if ($360.getCookie("hide_ann_bar") == "true") {
                dropdownPos = headerMenuHeight;
              } else {
                dropdownPos = headerHeight;
              }

              if (!body.classList.contains("no-bar")) {
                headerConObj.style.top = `0`;
              }
            } else {
              if ($360.getCookie("hide_ann_bar") == "true") {
                siteHeaderObj.style.transform = "translateY(0)";
              }

              headerConObj.style.top = `-${hideHeight}px`;
              siteHeaderObj.classList.add("scroll-top");
              headerConObj.classList.add("scroll-top");
              dropdownPos = headerMenuHeight;
            }

            // set menu dropdown top position
            const desktopDropdowns = document.querySelectorAll(
              "#header-con .menu-dropdown"
            );
            if (screen.width > 1023) {
              desktopDropdowns.forEach(function (desktopDropdown) {
                desktopDropdown.style.top = `${dropdownPos - 1}px`;
              });
            }
          }

          this_obj.prevScrollPos = scrollPos;
          this_obj.activeSubmenu = null;
          this_obj.activeSubsubmenu = null;
        });
      },
      showHeaderCart() {
        $360.showHeaderCart({},function() {initSwiperYmal();});
      },
      mainNavMouseLeave(e) {
        const delay = setTimeout(() => {
          const header_links = document.querySelectorAll(
            ".header-nav .header-link"
          );
          header_links.forEach(function (header_link) {
            header_link.classList.remove("mouseover");
            header_link.classList.remove("this-hovered");
          });

          clearTimeout(delay);
        }, 30);
      },
      showDropdown(submenu,subsubmenu, e) {
        e.preventDefault()
        this.activeSubmenu = submenu;
        this.activeSubsubmenu = subsubmenu
        $360.lazyLoadInstance.update();
        const delay = setTimeout(() => {
          const this_link = e.target.closest(".parent");
          if(this_link){
            const header_links = document.querySelectorAll(
              ".header-nav .header-link"
            );
            header_links.forEach(function (header_link) {
              header_link.classList.add("mouseover");
              header_link.classList.remove("this-hovered");
              if (header_link.closest(".parent") == this_link) {
                header_link.classList.remove("mouseover");
                header_link.classList.add("this-hovered");
              }
            });
          }
          const this_sublink = e.target
          const subheader_links = document.querySelectorAll(
            ".shd-submenu .subparent"
          );
          subheader_links.forEach(function (subheader_link) {
            subheader_link.classList.add("mouseover");
            subheader_link.classList.remove("this-hovered");
          });
          if(this_sublink.classList.contains('subparent')){
            this_sublink.classList.remove("mouseover");
            this_sublink.classList.add("this-hovered");
          }
          clearTimeout(delay);
        }, 30);
      },
      noDropdown(submenu,subsubmenu, e) {
        e.preventDefault()
        this.activeSubmenu = null;
        this.activeSubsubmenu = null;
        $360.lazyLoadInstance.update();
      },
      toggleMobileMenu(e) {
        if (e != null) {
          e.preventDefault();
        }
        let body = document.querySelector('body')
        this.showMobileMenu = !this.showMobileMenu
        if(this.showMobileMenu){
          body.classList.add('overflow')
        } else {
          this.activeSubmenu = null
          this.activeSubsubmenu = null
          body.classList.remove('overflow')
        }
        return false;
      }
    },
  });
  headerVue.mount("#header-con");
});

// script-custom.js
// header cart
function toggleInfoPoint() {
  let ip = document.querySelector('.hcb-info-popup')
  ip.classList.toggle('active')
}
function initSwiperYmal() {
  console.log('[YMAL] initSwiperYmal() called')
  // Start a one-time MutationObserver to watch for cart DOM replacements and re-init the slider
  try {
    if (!window.__ymalObserverStarted) {
      const schedule = () => {
        clearTimeout(window.__ymalInitDebounce)
        window.__ymalInitDebounce = setTimeout(() => {
          console.log('[YMAL] Mutation detected. Scheduling re-init...')
          initSwiperYmal()
        }, 120)
      }
      window.__ymalObserver = new MutationObserver((mutations) => {
        for (const m of mutations) {
          // If YMAL container or header cart subtree changes, schedule re-init
          if (
            (m.target && (m.target.classList && (m.target.classList.contains('header-cart-wrapper') || m.target.classList.contains('hcm-you-may-also-like') || m.target.classList.contains('hcmymal-swiper')))) ||
            [...m.addedNodes].some(n => n.nodeType === 1 && (n.classList?.contains('header-cart-wrapper') || n.classList?.contains('hcm-you-may-also-like') || n.classList?.contains('hcmymal-swiper')))
          ) {
            schedule()
            break
          }
        }
      })
      window.__ymalObserver.observe(document.body, {childList: true, subtree: true})
      window.__ymalObserverStarted = true
      console.log('[YMAL] MutationObserver started')
    }
  } catch (e) { console.warn('[YMAL] Failed to start MutationObserver:', e) }
  const tryInit = () => {
    console.log('[YMAL] tryInit running...')
    let targetEl = document.querySelector('.hcmymal-swiper')
    if (!targetEl) {
      console.log('[YMAL] .hcmymal-swiper not found. Retrying in 500ms...')
      setTimeout(tryInit, 500)
      return
    }

    // Ensure Swiper is available
    if (typeof Swiper === 'undefined') {
      console.warn('[YMAL] Swiper is not available yet. Retrying in 500ms...')
      setTimeout(tryInit, 500)
      return
    }

    // If container is hidden (width = 0), wait until visible to compute sizes correctly
    if (targetEl.offsetWidth === 0) {
      console.log('[YMAL] Slider container width is 0 (likely hidden/transitioning). Retrying in 200ms...')
      setTimeout(tryInit, 200)
      return
    }

    // If already initialized, destroy first to allow re-init with fresh DOM
    if (targetEl.swiper && typeof targetEl.swiper.destroy === 'function') {
      console.log('[YMAL] Existing Swiper instance detected. Destroying...')
      try { targetEl.swiper.destroy(true, true) } catch (e) { console.warn('[YMAL] Error destroying existing swiper:', e) }
      targetEl.classList.remove('swiper-initialized', 'swiper-horizontal', 'swiper-backface-hidden')
    } else {
      console.log('[YMAL] No existing Swiper instance on element.')
    }

    const containerEl = targetEl.closest('.hcm-you-may-also-like') || document
    const paginationEl = containerEl.querySelector('.hcmymal-pagination')
    console.log('[YMAL] Pagination element present?', !!paginationEl, 'Scoped within container:', containerEl !== document)

    // Ensure minimal Swiper CSS exists for YMAL to render properly (in case global Swiper CSS isn't loaded)
    try {
      if (!document.getElementById('ymal-swiper-inline-styles')) {
        const style = document.createElement('style')
        style.id = 'ymal-swiper-inline-styles'
        style.textContent = `
          .hcmymal-swiper { position: relative; overflow: hidden; }
          .hcmymal-swiper .swiper-wrapper { display: flex; will-change: transform; }
          .hcmymal-swiper .swiper-slide { flex-shrink: 0; width: 100%; }
          .hcmymal-pagination.swiper-pagination { position: static; }
        `
        document.head.appendChild(style)
        console.log('[YMAL] Injected minimal Swiper CSS for YMAL')
      }
    } catch (e) { console.warn('[YMAL] Failed to inject inline Swiper CSS:', e) }

    const instance = new Swiper(targetEl, {
      init: true,
      slidesPerView: 1,
      spaceBetween: 20,
      observer: true,
      observeParents: true,
      watchOverflow: false,
      allowTouchMove: true,
      breakpoints: {
        1024: {
          slidesPerView: 1,
          freeMode: false,
        },
      },
      pagination: paginationEl ? { el: paginationEl, clickable: true } : undefined,
      loop: false,
      a11y: false,
      on: {
        init: function () {
          console.log('[YMAL] Swiper init event fired. Slides:', this.slides ? this.slides.length : 'n/a')
          try { $360.lazyLoadInstance.update() } catch (e) { console.warn('[YMAL] lazyLoadInstance update error on init:', e) }
        },
        slideChange: function () {
          console.log('[YMAL] Swiper slideChange. Active index:', this.activeIndex)
          try { $360.lazyLoadInstance.update() } catch (e) { console.warn('[YMAL] lazyLoadInstance update error on slideChange:', e) }
        },
        resize: function () {
          console.log('[YMAL] Swiper resize event.')
          try { $360.lazyLoadInstance.update() } catch (e) { console.warn('[YMAL] lazyLoadInstance update error on resize:', e) }
        },
      },
    })

    // Expose for debugging
    try { window.__hcmymalSwiper = instance } catch (e) {}
    console.log('[YMAL] Swiper initialized:', !!instance, 'Params:', instance && instance.params)
    try {
      const wrapper = targetEl.querySelector('.swiper-wrapper')
      const slides = targetEl.querySelectorAll('.swiper-slide')
      console.log('[YMAL] Sizes — container:', targetEl.offsetWidth, 'wrapper:', wrapper ? wrapper.offsetWidth : 'n/a', 'slide[0]:', slides[0] ? slides[0].offsetWidth : 'n/a')
    } catch (e) {}

    // Verify the initialized class is present; if not, retry shortly (likely due to DOM replacement)
    setTimeout(() => {
      const hasInitV8 = targetEl.classList.contains('swiper-initialized')
      const hasInitV5 = targetEl.classList.contains('swiper-container-initialized')
      const hasInstance = !!targetEl.swiper
      console.log('[YMAL] Post-check classes:', targetEl.className)
      console.log('[YMAL] Post-check: v8(.swiper-initialized)=', hasInitV8, ' v5(.swiper-container-initialized)=', hasInitV5, ' hasInstance=', hasInstance)
      if (!hasInitV8 && !hasInitV5) {
        if (instance && typeof instance.init === 'function') {
          try { instance.init(); console.log('[YMAL] Called instance.init() fallback') } catch (e) { console.warn('[YMAL] Error calling instance.init():', e) }
        }
        // As last resort, mark as initialized to satisfy CSS that depends on the class
        try {
          targetEl.classList.add('swiper-initialized')
          console.warn('[YMAL] Manually added .swiper-initialized class as fallback')
        } catch (e) {}
        // Schedule another verification
        setTimeout(() => {
          const againV8 = targetEl.classList.contains('swiper-initialized')
          const againV5 = targetEl.classList.contains('swiper-container-initialized')
          console.log('[YMAL] Recheck after fallback: v8=', againV8, ' v5=', againV5, ' hasInstance=', !!targetEl.swiper)
          if (!againV8 && !againV5) {
            console.warn('[YMAL] Still missing initialized class. Retrying init...')
            tryInit()
          }
        }, 120)
      }
    }, 150)

    // Force an update after a short delay to ensure correct sizes after drawer transition
    setTimeout(() => {
      try { instance.update(); console.log('[YMAL] Swiper.update() called after init') } catch (e) { console.warn('[YMAL] Error calling Swiper.update():', e) }
    }, 100)

    // Also force update after drawer transition completes (if any)
    try {
      const drawerEl = targetEl.closest('.header-cart-wrapper')
      if (drawerEl) {
        const onTe = () => {
          try { instance.update(); console.log('[YMAL] Swiper.update() after drawer transitionend') } catch (e) {}
          drawerEl.removeEventListener('transitionend', onTe)
        }
        drawerEl.addEventListener('transitionend', onTe)
      }
    } catch (e) {}
  }

  tryInit()
}
let pointsTimeoutId;

function calculatePoints(checkout_method = null) {
  const silver = 10;
  const gold = 15;
  const platinum = 20;
  const points = document.querySelector('#points-input');
  const pointsEl = document.querySelector('.hcb-info .points-amount');
  if (pointsEl) {
    if (!pointsEl.innerText.includes('points')) {
      pointsEl.innerHTML = '...';
    }
  }

  if (points) {
    const grand_total = points.getAttribute('data-grand-total') / 100;
    const tax_amount = points.getAttribute('data-tax-amount') / 100;
    let shipping_fee = points.getAttribute('data-shipping-fee') / 100;
    const donation = points.getAttribute('data-donation') / 100;

    clearTimeout(pointsTimeoutId);

    pointsTimeoutId = setTimeout(() => {
      const checkoutMethodEl = document.querySelector('.checkoutMethod.active');
      let checkoutMethod;

      if (checkoutMethodEl && pointsEl) {
        checkoutMethod = checkoutMethodEl.innerText;

        if (
          (checkoutMethod === 'Local Delivery' && grand_total > 120) ||
          checkoutMethod === 'Store Pickup'
        ) {
          shipping_fee = 0;
        }

        let total_points = Math.floor((grand_total - tax_amount - shipping_fee - donation) * silver);
        total_points = total_points.toLocaleString('id-ID')
        if (pointsEl.innerText !== `${total_points} points`) {
          pointsEl.innerHTML = `${total_points} points`;
        }
      } else {
        pointsTimeoutId = setTimeout(() => {
          calculatePoints();
        }, 1000);
      }
    }, 500);
  }
}
async function giftProductToggle(e) {
  e.preventDefault();

  let target = e.target;
  let parent = target.closest(".hcmd-gift-message-box");
  let checkbox = parent.querySelector('#hcmd-gift-message')
  let msg = parent.querySelector("#gift-msg");
  let varId = parent.querySelector('#gmp-variant-id').value
  let loading = parent.querySelector('.hcmdgm-loading')
  let cart = await axios.get(window.Shopify.routes.root + "cart.js");
  if (cart.status == 200 && cart.data) {
    let giftMessage = cart.data.items.findIndex(
      (item) => item.properties["_isGiftMessage"]
    );
    async function addGiftMessage(){
      let args = {
        id: varId,
        quantity: 1,
        properties: {
          "Gift Message": msg.value,
          _isGiftMessage: true,
        },
      };
      // loading.classList.toggle('active')
      try {
        let addToCart = await axios.post('/cart/add.js', args)
        if(addToCart.status == 200 || addToCart.status == 201){
          updateTotalCart()
        }
        // loading.classList.toggle('active')
      } catch (error) {
        // loading.classList.toggle('active')
      }
    }
    async function removeGiftMessage(){
      // loading.classList.toggle('active')
      try {
        let args = { line: giftMessage + 1, quantity: 0, groupId: null, removeSameGroup: null }
        const updateCart = await axios.post('/cart/change.js', args);
        if(updateCart.status == 200 || updateCart.status == 201){
          updateTotalCart()
        }
        // loading.classList.toggle('active')
      } catch (error) {
        // loading.classList.toggle('active')
      }
    }
    async function updateTotalCart() {
      try {
        let cart = await axios.get('/cart?view=total')
        let subtotalEl = document.querySelector('.hc-cart-subtotal')
        if(cart.status == 200 || cart.status == 201){
          subtotalEl.innerHTML = cart.data
        }
      } catch (error) {
        
      }
    }
    if(checkbox.checked && msg.value){
      if (giftMessage < 0) {
        addGiftMessage()
      } else {
        removeGiftMessage()
        setTimeout(()=>{
          addGiftMessage()
        },500)
      }
    } else {
      if (giftMessage > -1) {
        removeGiftMessage()
      }
    }
  }
}
let giftTitle = document.querySelector(".hcb-gifting .accordion-title");
if (giftTitle != null) {
  giftTitle.addEventListener("click", function () {
    $360.adjustCartHeight();
  });
}
let zapietOpt = document.querySelectorAll(
  "#storePickupApp .checkoutMethod"
);
zapietOpt.forEach((i) => {
  i.addEventListener("click", function () {
    setTimeout(function () {
      setDeliveryNotes();
    }, 2000);
  });
});
function setDeliveryNotes() {
  let formHeaderCart = document.querySelector("form#header-cart");
  let checkoutBtn = document.querySelector(".checkout-btn");
  let deliveryNotes = document.querySelector("#order-notes");
  let dnValue;
  if (deliveryNotes) {
    dnValue = deliveryNotes.value;
  }
  if (formHeaderCart) {
    let formAction = formHeaderCart.getAttribute("action");
    if (formAction.includes("note=")) {
      formAction = formAction.replace(/(&|\?)?note=[^&]*/g, "");
    }
    formAction = formAction + "?note=" + dnValue;
    formHeaderCart.setAttribute("action", formAction);
  }
  if (checkoutBtn) {
    let cbhref = checkoutBtn.getAttribute("href");
    cbhref = "/checkout?note=" + dnValue;
    checkoutBtn.setAttribute("href", cbhref);
  }
}

// ------------------------------
// Gift Message Counter Utilities
// ------------------------------
window.updateGiftMsgCounter = function(el){
  try {
    if(!el) return;
    var max = Number(el.getAttribute('maxlength') || 255);
    var len = (el.value || '').length;
    var counter = document.getElementById('gift-msg-counter');
    if(counter){ counter.textContent = len; }
    // Optional: visual warning when near limit (no CSS assumptions)
    if(len >= max && el.classList){ el.classList.add('limit-reached'); }
    else if(el.classList){ el.classList.remove('limit-reached'); }
  } catch(e) {}
};

function initGiftMsgCounter(){
  try {
    var el = document.getElementById('gift-msg');
    if(el){ window.updateGiftMsgCounter(el); }
  } catch(e) {}
}

// Update on typing via delegated listener (covers dynamically injected nodes)
document.addEventListener('input', function(e){
  var t = e.target;
  if(t && t.id === 'gift-msg'){
    window.updateGiftMsgCounter(t);
  }
});

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', function(){
  initGiftMsgCounter();
});

// Re-initialize whenever header cart content updates
(function(){
  try {
    var container = document.querySelector('.header-cart-wrapper') || document.body;
    var observer = new MutationObserver(function(mutations){
      for(const m of mutations){
        // If the gift message textarea appears/changes in the DOM, update the counter
        if((m.target && m.target.querySelector && m.target.querySelector('#gift-msg')) ||
           ([...m.addedNodes].some(n => n.nodeType === 1 && (n.id === 'gift-msg' || (n.querySelector && n.querySelector('#gift-msg')))))){
          initGiftMsgCounter();
          break;
        }
      }
    });
    observer.observe(container, { childList: true, subtree: true });
  } catch(e) {}
})();
function toggleViewCart(target,el){
  let parent = document.querySelector('#header-cart')
  let titles = parent.querySelectorAll('.hcwt-item')
  let fsi = parent.querySelector('.free-shipping-info')
  let hci = parent.querySelector('.hc-info')
  let hcmc = parent.querySelector('.hcm-cart')
  let hcmd = parent.querySelector('.hcm-delivery')
  let checkout_btn = document.querySelector('.checkout-btn')
  let checkout_btn_next = document.querySelector('.checkout-btn-next')
  titles.forEach(item => item.classList.remove('active'))
  el.classList.add('active')
  if(target == 'cart'){
    fsi.classList.remove('hide-m')
    hci.classList.remove('hide-m')
    hcmc.classList.add('active')
    hcmd.classList.remove('active')
    checkout_btn.classList.add('hide-m')
    checkout_btn_next.classList.remove('hide-m')
  } else {
    fsi.classList.add('hide-m')
    hci.classList.add('hide-m')
    hcmc.classList.remove('active')
    hcmd.classList.add('active')
    checkout_btn.classList.remove('hide-m')
    checkout_btn_next.classList.add('hide-m')
  }
  setDeliveryNotes()
}
async function addDonation() {

  const donation_select = document.querySelector('#hc-donation-amount')
  const qty = 1;
  const variantId = donation_select.value;
  let properties = null;
  const button = document.querySelector('.hcmd-btn');
  const donationName = button && button.getAttribute ? button.getAttribute('data-donation-name') : null;
  if (donationName) {
    properties = { _donationName: donationName };
  }

  let prevText;
  if(button) {
      prevText = button.innerHTML;
      const btnLoading = 'Processing donation...';
      button.style.height = `${button.offsetHeight}px`;
      button.innerHTML = btnLoading;
      button.setAttribute('disabled', true);

      const delay_animate = setTimeout(() => {
          button.classList.add('is-loading');

          clearTimeout(delay_animate);
      }, 100);
  }
  
  const data = {quantity: qty, id: variantId};

  if(properties) {
      data.properties = properties;
  }
  try {
    let cartcurrent = await axios.get('/cart.js');
    let donation_product_id = Number(document.querySelector('.hcm-donations').getAttribute('data-product-id'));

    if ((cartcurrent.status === 200 || cartcurrent.status === 201) && cartcurrent.data.items) {
      let cart_items = cartcurrent.data.items;
      let updatePromises = [];
      const variantIdsToRemove = [];
      cart_items.forEach((ci, i) => {
        let item_product_id = Number(ci.product_id);
        if (item_product_id === donation_product_id) {
          variantIdsToRemove.push(ci.variant_id)
        }
      });
      const updates = {};
      cart_items.forEach(item => {
        if (variantIdsToRemove.includes(item.variant_id)) {
          updates[item.id] = 0; 
        }
      });
      if (Object.keys(updates).length > 0) {
        await axios.post('/cart/update.js', {
          updates: updates
        });
      }
    }

    // Now add to cart after donation items removed
    const addToCart = await axios.post('/cart/add.js', data);
    const cart = addToCart.data;

    $360.showHeaderCart({ update: true }); 
    $360.refreshCartPage();
    initSwiperYmal();

    if (callback) {
      callback(cart);
    }
  } catch (error) {
      if(error.response){
          alert(error.response.data.message);
      }
  } finally {
      if(button) {
          const delay_button = setTimeout(() => {
              button.innerHTML = prevText;
              button.removeAttribute('disabled');
              button.style.height = '';
              //button.style.width = '';
              button.classList.remove('is-loading');

              clearTimeout(delay_button);
          }, 1000);
      }
  }
}
async function atcProductYmal(args,callback){
  const qty = args.qty;
  const variantId = args.variantId;
  const properties = args.properties;
  const button = args.button;

  let prevText;
  if(button) {
      prevText = button.innerHTML;
      const btnLoading = '<span class="btn-loading"></span>';
      button.style.height = `${button.offsetHeight}px`;
      button.innerHTML = btnLoading;
      button.setAttribute('disabled', true);

      const delay_animate = setTimeout(() => {
          button.classList.add('is-loading');

          clearTimeout(delay_animate);
      }, 100);
  }
  
  const data = {quantity: qty, id: variantId};

  if(properties) {
      data.properties = properties;
  }

  try {
      const addToCart = await axios.post('/cart/add.js', data);
      const cart = addToCart.data;
      $360.showHeaderCart({update: true}); 
      $360.refreshCartPage();
      initSwiperYmal();
      if(callback) {
          callback(cart);
      }
  } catch (error) {
      if(error.response){
          alert(error.response.data.message);
      }
  } finally {
      if(button) {
          const delay_button = setTimeout(() => {
              button.innerHTML = prevText;
              button.removeAttribute('disabled');
              button.style.height = '';
              //button.style.width = '';
              button.classList.remove('is-loading');

              clearTimeout(delay_button);
          }, 1000);
      }
  }
}
function removeDonation() {
  let donation_el = document.querySelector('.donation-box')
  donation_el.classList.add('hide-m')
}

// ---------------------------------------------
// Global Select: sync UI on change/click events
// ---------------------------------------------
function syncGlobalSelectUI(selectEl) {
  if (!selectEl) return;
  const wrapper = selectEl.closest('.global-select-div');
  if (!wrapper) return;

  // Update visible selected text
  const selectedOption = selectEl.options[selectEl.selectedIndex];
  const selectedText = selectedOption ? selectedOption.textContent : '';
  const textEl = wrapper.querySelector('.inner .text');
  if (textEl && selectedText !== undefined) {
    textEl.textContent = selectedText;
  }

  // Update active state in custom options list
  const value = selectEl.value;
  const optionLis = wrapper.querySelectorAll('.options .option');
  optionLis.forEach((li) => {
    const isActive = (li.getAttribute('data-value') || '') == value;
    li.classList.toggle('active', !!isActive);
    const labelEl = li.querySelector('span, a');
    if (labelEl) {
      labelEl.classList.toggle('semibold-600', !!isActive);
      labelEl.classList.toggle('c-maroon', !!isActive);
    }
  });
}

// Delegated change listener for native select inside global-select
document.addEventListener('change', function (e) {
  const select = e.target && e.target.matches('.global-select-div select')
    ? e.target
    : (e.target && e.target.closest && e.target.closest('.global-select-div select'));
  if (select) {
    syncGlobalSelectUI(select);
  }
});

// Delegated click listener for custom option list to reflect into the native select
document.addEventListener('click', function (e) {
  const optionEl = e.target && e.target.closest && e.target.closest('.global-select-div .options .option');
  if (!optionEl) return;
  const wrapper = optionEl.closest('.global-select-div');
  const select = wrapper ? wrapper.querySelector('select') : null;
  const value = optionEl.getAttribute('data-value');
  if (select && value !== null) {
    const prev = select.value;
    select.value = value;
    syncGlobalSelectUI(select);
    // Fire change if value actually changed so any external logic runs
    if (prev !== value) {
      try {
        const evt = new Event('change', { bubbles: true });
        select.dispatchEvent(evt);
      } catch (err) {
        // IE fallback (not required for modern browsers, just in case)
        if (document.createEvent) {
          const evt = document.createEvent('HTMLEvents');
          evt.initEvent('change', true, false);
          select.dispatchEvent(evt);
        }
      }
    }
  }
});

// Initialize current state on DOM ready (handles server-rendered default selections)
document.addEventListener('DOMContentLoaded', function (){
  document.querySelectorAll('.global-select-div select').forEach((sel) => {
    syncGlobalSelectUI(sel);
  });
});

// ---------------------------------
// Global Zapiet setup (outside Vue)
// ---------------------------------
(function(){
  try {
    if (window.__zapietSetupDone) return;
    window.__zapietSetupDone = true;

    const toggleHeaderCheckout = (enable) => {
      try {
        const btns = document.querySelectorAll('form#header-cart .checkout-btn');
        btns.forEach((b) => {
          if (enable) b.classList.remove('disabled');
          else b.classList.add('disabled');
        });
      } catch (e) {}
    };

    const setZapietTimestamp = (e) => {
      try {
        const selected_date = e && e.date;
        const selected_time = e && e.start_time;
        if (!selected_date || !selected_time) return;
        const date_time = `${selected_date} ${selected_time}`;
        const date = new Date(date_time);
        const timestamp = Math.floor(date.getTime() / 1000);
        const input_elem = document.querySelector('input[name="attributes[_timestamp]"]');
        if (input_elem) input_elem.value = timestamp;
      } catch (err) {}
    };

    const tryStartWidgetIfMissing = () => {
      try {
        const zapietWidget = document.querySelector('.checkoutMethodsContainer');
        if (zapietWidget == null) {
          Zapiet.start(ZapietWidgetConfig);
        }
      } catch (e) {}
    };

    const updateShippingFee = async () => {
      try {
        // Get shipping fee element
        const shipping_fee_elem = document.querySelector('.cart-drawer-shipping');
        if (!shipping_fee_elem) return;

        // Get settings from free-shipping-info element (which has pre-calculated values from Liquid)
        const freeShippingInfo = document.querySelector('.free-shipping-info');
        if (!freeShippingInfo) {
          shipping_fee_elem.innerHTML = "Calculated at checkout";
          return;
        }

        // Get pre-calculated values from data attributes
        const cart_total = parseFloat(freeShippingInfo.getAttribute('data-ct')) || 0;
        const free_shipping = parseFloat(freeShippingInfo.getAttribute('data-fs')) || 0;
        const standardFeeAttr = freeShippingInfo.getAttribute('data-standard-fee');

        // Check if free shipping threshold is configured
        if (free_shipping === 0) {
          // No free shipping threshold configured
          if (standardFeeAttr && standardFeeAttr !== '') {
            const fee = parseFloat(standardFeeAttr) * 100;
            // Format money using Shopify's money format
            shipping_fee_elem.innerHTML = formatMoneyWithCurrency(fee);
          } else {
            shipping_fee_elem.innerHTML = "Calculated at checkout";
          }
          return;
        }

        // Check if cart meets free shipping threshold
        if (cart_total >= free_shipping) {
          shipping_fee_elem.innerHTML = "Free";
        } else {
          // Show standard shipping fee
          if (standardFeeAttr && standardFeeAttr !== '') {
            const fee = parseFloat(standardFeeAttr) * 100;
            shipping_fee_elem.innerHTML = formatMoneyWithCurrency(fee);
          } else {
            shipping_fee_elem.innerHTML = "Calculated at checkout";
          }
        }
      } catch (err) {
        console.error('Error updating shipping fee:', err);
        // Fallback on error
        const shipping_fee_elem = document.querySelector('.cart-drawer-shipping');
        if (shipping_fee_elem) {
          shipping_fee_elem.innerHTML = "Calculated at checkout";
        }
      }
    };

    const formatMoneyWithCurrency = (cents) => {
      // Use Shopify's money formatting if available
      if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents, Shopify.money_format || '{{amount}}');
      }
      // Fallback formatting
      const amount = (cents / 100).toFixed(2);
      return `$${amount}`;
    };

    const wireZapietEvents = () => {
      try {
        window.ZapietEvent.listen('checkoutEnabled', function(e) {
          toggleHeaderCheckout(true);
          setZapietTimestamp(e);
        });
        window.ZapietEvent.listen('checkoutDisabled', function() {
          toggleHeaderCheckout(false);
        });
        // Preserve existing points calculation on method selection
        try {
          window.ZapietEvent.listen('selected_method', async function(checkout_method) {
            toggleHeaderCheckout(false);
            
            if(checkout_method == 'pickup') {
              let shipping_fee_elem = document.querySelector('.cart-drawer-shipping');
              if(shipping_fee_elem != null) {
                shipping_fee_elem.innerHTML = "Free";
              }
            } else {
              // Calculate shipping fee based on cart total and free shipping threshold
              await updateShippingFee();
            }

            try { calculatePoints(checkout_method); } catch (err) {}
          });
        } catch (err) {}
      } catch (err) {}
    };

    const checkInterval = setInterval(() => {
      if (window.ZapietEvent !== undefined && window.ZapietEvent) {
        clearInterval(checkInterval);

        // Ensure initial disabled state until enabled
        toggleHeaderCheckout(false);

        // If widget not present, try to start it after 0.7s
        const checkWidget = setTimeout(function(){
          tryStartWidgetIfMissing();
          clearTimeout(checkWidget);
        }, 700);

        wireZapietEvents();
      }
    }, 500);
  } catch (e) {}
})();
